import { Building2 } from 'lucide-react';

export const CompanyBanner = ({
  companyName,
  locationAddress,
}: {
  companyName: string;
  locationAddress: string | null;
}) => (
  <div className="flex items-center gap-3 rounded-lg border bg-card p-3">
    <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-primary">
      <Building2 className="size-5 text-primary-foreground" />
    </div>
    <div className="min-w-0">
      <p className="truncate text-sm font-semibold">{companyName}</p>
      {locationAddress && (
        <p className="truncate text-xs text-muted-foreground">{locationAddress}</p>
      )}
    </div>
  </div>
);
